module.exports = __webpack_public_path__ + "img/cladire4.e44fce0b.jpeg";